// Coerces an axios error into a display-safe string. FastAPI/Pydantic
// v2 returns `detail` as EITHER a plain string OR an array of validation
// error dicts ({type, loc, msg, input, url}). Rendering the array
// directly via toast.error() would crash React with "Objects are not
// valid as a React child". This helper always returns a string.
export const formatApiError = (err, fallback = "Something went wrong") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail
      .map((d) => (d && typeof d.msg === "string") ? d.msg : JSON.stringify(d))
      .join("; ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || JSON.stringify(detail);
  }
  return err?.message || fallback;
};
